module.exports = __webpack_public_path__ + "img/imgClient.41fd9690.png";